export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const scriptUrl = String(config.public.analyticsScript ?? '').trim()
  const domain = String(config.public.analyticsDomain ?? '').trim()

  if (!import.meta.client) return
  if (scriptUrl) {
    useHead({
      script: [{ src: scriptUrl, defer: true, 'data-domain': domain || undefined }],
    })
    return
  }

  if (domain) {
    useHead({
      script: [{ src: 'https://plausible.io/js/script.js', defer: true, 'data-domain': domain }],
    })
  }
})
